import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { MoreHorizontal, Eye, Plus } from 'lucide-react';
import PaginationComponent from '@/components/common/PaginationComponent';
import { formatTableText } from '@/lib/tableUtils';

const MissingWagonReceiptsTable = ({
  trips,
  currentPage,
  totalPages,
  totalTrips,
  pageSize,
  onPageChange,
  onViewReceipts,
  onAddMissingWagon,
}) => {
  return (
    <>
      <div className="rounded-md border overflow-hidden w-full">
        <div className="max-h-[calc(100vh-250px)] overflow-auto w-full">
          <Table>
            <TableHeader className="sticky top-0 z-10">
              <TableRow>
                <TableHead className="h-10 px-4 py-1">Trip Number</TableHead>
                <TableHead className="h-10 px-4 py-1">RR Number</TableHead>
                <TableHead className="h-10 px-4 py-1">Rake Point</TableHead>
                <TableHead className="h-10 px-4 py-1">Product</TableHead>
                <TableHead className="h-10 px-4 py-1">Baseline Qty</TableHead>
                <TableHead className="h-10 px-4 py-1">Received Qty</TableHead>
                <TableHead className="h-10 px-4 py-1">Missing Wagons</TableHead>
                <TableHead className="h-10 px-4 py-1 text-right min-w-[80px]">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {trips.map((trip) => {
                const baseline = trip.baseline_qty_mt || trip.total_dispatched_qty_mt || 0;

                return (
                  <TableRow key={trip.id} className="hover:bg-transparent border-border">
                    <TableCell className="h-10 px-4 py-1 font-semibold text-primary">
                      {formatTableText(trip.trip_number)}
                    </TableCell>
                    <TableCell className="h-10 px-4 py-1">
                      {formatTableText(trip.rr_number)}
                    </TableCell>
                    <TableCell className="h-10 px-4 py-1">
                      {formatTableText(trip.rake_point?.name || trip.rake_point_name)}
                    </TableCell>
                    <TableCell className="h-10 px-4 py-1">
                      {formatTableText(trip.items?.[0]?.product_type?.name || trip.product_name)}
                    </TableCell>
                    <TableCell className="h-10 px-4 py-1">
                      {baseline ? `${parseFloat(baseline).toFixed(2)} MT` : '—'}
                    </TableCell>
                    <TableCell className="h-10 px-4 py-1">
                      {trip.receipt_qty !== null && trip.receipt_qty !== undefined
                        ? `${parseFloat(trip.receipt_qty).toFixed(2)} MT`
                        : '—'}
                    </TableCell>
                    <TableCell className="h-10 px-4 py-1 font-medium">
                      {trip.missing_wagons !== null && trip.missing_wagons !== undefined ? trip.missing_wagons : '0'}
                    </TableCell>
                    <TableCell className="h-10 px-4 py-1 text-right">
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                          <Button variant="ghost" size="icon">
                            <MoreHorizontal className="h-4 w-4" />
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end">
                          <DropdownMenuItem onClick={() => onViewReceipts(trip)}>
                            <Eye className="mr-2 h-4 w-4" />
                            View Receipts
                          </DropdownMenuItem>
                          <DropdownMenuItem onClick={() => onAddMissingWagon(trip)}>
                            <Plus className="mr-2 h-4 w-4" />
                            Add Missing Wagon
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>

        <PaginationComponent
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalTrips}
          pageSize={pageSize}
          onPageChange={onPageChange}
          className="border-t"
        />
      </div>
    </>
  );
};

export default MissingWagonReceiptsTable;
